import React from "react";
import { useEffect, useRef, useState } from "react";


import Typography from "../typography/typography";
import { Box } from "@mui/material";
import "./upload-excel.scss";
import { useDropzone } from "react-dropzone";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grow,
  IconButton,
  
} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
// import Checkbox from "../checkbox/checkbox";
import Avatar from "../avatar/avatar";
import images from "../../assets/images";
import ModalLoader from '../loaders/modal-loader';
import {Trash} from '../icons';

import { KeyboardArrowDown, KeyboardArrowUp, Upload } from "@mui/icons-material";
import { postImportSheet } from "../../utils/common";
import Button from "../button/button";


interface UploadProps {
  open: boolean;
  title: string;
  multiple?: boolean;
  accept?: string;
  showCameraButton?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onSubmit?: (files: any[]) => void;
  existingDriveData?: any;
  importModuleName?: any;
  pageName?: any;
  handleSuccessImport?: (e?: any) => void;

}

const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

const UploadExcel = (props: UploadProps) => {
  const {
    open,
    title,
    onClose,
    onConfirm,
    onSubmit,
    accept = "*",
    multiple = false,
    importModuleName,
    pageName,
    handleSuccessImport
  } = props;
  const [files, setFiles] = useState<
    {
      file: File;
      isPrivate: boolean;
      checkboxDisabled: boolean;
      status: string;
      uploadProgress: number;
      fileSize: number;
      fileName: string;
      fileType: string;
      location: string;
      message: string;
    }[]
  >([]);

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isDialogMinimized, setIsDialogMinimized] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const [dataResult, setDataResult] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDropAccepted: (newFiles) => {
      setFiles([
        ...files,
        ...newFiles.map((file) => ({
          file,
          isPrivate: false,
          checkboxDisabled: false,
          status: "pending",
          uploadProgress: 0,
          fileSize: file.size,
          fileName: file.name,
          fileType: file.type,
          location: "",
          message: "",
        })),
      ]);
      setIsDragOver(false);
    },
    onDragEnter: () => {
      setIsDragOver(true);
    },
    onDragLeave: () => {
      setIsDragOver(false);
    },
    noClick: true,
    noKeyboard: true,
    multiple: multiple,
    accept: accept ? convertAcceptObject(accept) : accept,
  });

  const handleClose = () => {
    onClose()
    setDataResult(null);
  }

  const fileInputRef = useRef<HTMLInputElement>(null);

  // useEffect(() => {
  //   const driveTitles = existingDriveData.map(item => item['title'])
  //   setAllDriveData(driveTitles);
  // }, [existingDriveData]);


  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      
        const message =
          "Are you sure you want to leave? Your uploads are not complete.";
        event.returnValue = message; // Standard for most browsers
        return message; // For some older browsers
      
    };
    if (fileInputRef.current) {
      fileInputRef.current.multiple = multiple;
    }

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [ multiple]);

 

  function convertAcceptObject(types: string) {
    const accepts = types.split(",").map((item) => item.trim());
    const acceptObject = accepts.reduce((acc: any, type: string) => {
      acc[type] = [];
      return acc;
    }, {});
    return acceptObject;
  }

  const renderFileIcon = (file: any) => {
    const fileType = file?.type.split("/")[0];
    switch (fileType) {
      case "image":
        return (
          <div
            className={
              isDialogMinimized ? "document-icon-sm" : "document-icon-lg"
            }
            style={{ backgroundColor: "#FFEBEB" }}
          >
            <Avatar size={20} src={images.upload.documentPDF}></Avatar>
          </div>
        );
      case "application":
        return (
          <div
            className={
              isDialogMinimized ? "document-icon-sm" : "document-icon-lg"
            }
            style={{ backgroundColor: "#FFEBEB" }}
          >
            <Avatar size={150} src={images.upload.documentPDF} alt={"PDF"}></Avatar>
            <Typography color="theme.secondary.1000" weight="bold" type="s2">{file.name}</Typography>
            <Typography color="theme.secondary.800" type="s5">{formatBytes(file.size)}</Typography>
          </div>
        );
      case "text":
        return (
          <div
            className={
              isDialogMinimized ? "document-icon-sm" : "document-icon-lg"
            }
            style={{ backgroundColor: "#EBF9F2" }}
          >
            <Avatar size={20} src={images.upload.docFile}></Avatar>
          </div>
        );
      default:
        return (
          <div
            className={
              isDialogMinimized ? "document-icon-sm" : "document-icon-lg"
            }
            style={{ backgroundColor: "#EBF9F2" }}
          >
            <Avatar size={20} src={images.upload.docFile}></Avatar>
          </div>
        );
    }
  };

 

  const handleChipClick = () => {
    if (fileInputRef.current) {
      // If multiple is true, set input for multiple files
      if (props.multiple) {
        fileInputRef.current.setAttribute("multiple", "true");
      } else {
        // If multiple is false, set input for a single file
        fileInputRef.current.removeAttribute("multiple");
      }
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e: any) => {
    // importData(e.target.files[0]);
    const file = e.target.files?.[0] || null;
    const f = {
      file,
      isPrivate: false,
      checkboxDisabled: false,
      status: "pending",
      uploadProgress: 0,
      fileSize: file.size,
      fileName: file.name,
      fileType: file.type,
      location: "",
      message: "",
    }

    
    setFiles([
      ...files,
      ...[f],
    ]);
  };

  const removeFile = (indexToRemove: number) => {

    setFiles((prevFiles) =>
      prevFiles.filter((file, index) =>index !== indexToRemove
      ),
    );
  };

  // const toggleIsPrivate = (index: number) => {
  //   setFiles((prevFiles) =>
  //     prevFiles.map((item, i) =>
  //       i === index ? { ...item, isPrivate: !item.isPrivate } : item,
  //     ),
  //   );
  // };

  const toggleCollapse = () => {
    setIsCollapsed((prevIsCollapsed) => !prevIsCollapsed);
  };

  const handleMinimizeClick = () => {
    setIsDialogMinimized(!isDialogMinimized);
    isDialogMinimized ? onConfirm() : onClose();
  };

  const importData = async () => {
    const file = files[0].file
		const formData = new FormData();
		formData.append('file', file);  // Ensure the field name is correct.
		setIsLoading(true)
		try {
			const response = await postImportSheet(formData, importModuleName, pageName);
			if(response) {
				setDataResult(response.data)
        setIsLoading(false)
        if(response?.data?.failed?.length == 0){
          handleClose()
          handleSuccessImport(response?.data);
        }
			} 
		} catch (error) {
      setIsLoading(false)
		}

	}

  useEffect(() => {
    open && setFiles([]);
  }, [open]);



  return (
    <>
      <Dialog open={open} onClose={handleClose} className="upload">
        <DialogTitle className="upload--head">
          <Box className="upload--title">
            <Typography
              type="s3"
              ml={1}
              weight="medium"
              color="theme.secondary.1000"
            >
              {title}
            </Typography>
          </Box>
      
        </DialogTitle>
        <Divider />
        <DialogContent className="upload--content">
          {isLoading && <ModalLoader />}
         
          {files.length === 0 ? (
              <div
                className={`upload--fileContent ${isDragActive ? "drag-active" : ""
                  }`}
              >
                <div {...getRootProps()} className="drop-view">
                  {!isDragOver ? (
                    <>
                      <input {...getInputProps()} ref={fileInputRef} />
                      <p className="upload--text">
                        Drag and Drop files here or upload from
                      </p>

                      <div className="device-wrap">
                        <div className="select-button" onClick={handleChipClick}>
                          <img src={images.upload.monitor} />
                          <Typography type="s5">My Device</Typography>
                          <input
                            type="file"
                            {...getInputProps({ multiple: true })}
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                            accept={accept}
                          />
                        </div>
                      
                      </div>

                    {dataResult?.successful?.length || dataResult?.failed?.length ? (
                      <div className ="mt-2">
                        {dataResult?.failed.length == 0 ? (
                          <Typography type="s3">
                            All data imported successfully.
                          </Typography> ) : (
                          <Typography type="s4" word-break="break-word" color="theme.error.600" weight="medium">
                          Failed to import the following records with IDs: {dataResult.failed?.map((item:any)=>item?.id).join(", ")}
                          </Typography> )
                        }     
                      </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <div className="after-drop">
                      <img src={images.upload.documentUpload} />
                      <Typography type="s3">
                        Drag & Drop your files here
                      </Typography>
                    </div>
                  )}
                </div>
              </div>
          ) : (
              <Grow in={Boolean(files?.length)} timeout={500}>
                <Box>
                    {files.map((file: any, index: number) => (
                        <Box key={file?.file?.name} display='flex' width='100%' justifyContent='center' alignItems='center' flexDirection='column'>
                          <Box className="icon-BG">
                            <IconButton onClick={() => removeFile(index)} className="remove-button"><Trash fontSize='small' /> </IconButton>
                            <Avatar size={150} src={images.upload.docFile} alt={"PDF"}></Avatar>
                          </Box>
                          <Typography type="s2" weight="bold" color='theme.secondary.1000'>{file?.file?.name}</Typography>
                          <Typography type="s4" color='theme.secondary.800'>{formatBytes(file?.file?.size)}</Typography>
                        </Box>
                    ))}
                    {dataResult?.successful?.length || dataResult?.failed?.length ? (
                      <div className ="mt-2">
                        {dataResult?.failed.length == 0 ? (
                          <Typography type="s3">
                            All data imported successfully.
                          </Typography> ) : (
                          <Typography type="s4" word-break="break-word" color="theme.error.600" weight="medium">
                          Failed to import the following records with IDs: {dataResult?.failed?.map((item:any)=>item.id).join(", ")}
                          </Typography> )
                        }     
                      </div>
                    ) : (
                      ""
                    )}
                </Box>
            </Grow>
          )}
        </DialogContent>
        <DialogActions className="uploadActions">
          <Button onClick={onSubmit ? ()=>{
            onSubmit(files)
          } : importData} startIcon={<Upload />}>Upload</Button>
        </DialogActions>
      </Dialog>
      {isDialogMinimized && (
        <div className="bottom-corner-box">
          <div className="top-section">
            <div className="top-text">
              Uploading {files.length} Item{files.length !== 1 ? "s" : ""}
            </div>
            <div className="top-options">
              <div className="btn" onClick={handleMinimizeClick}>
                <RemoveIcon />
              </div>
              <div className="btn" onClick={toggleCollapse}>
                <div className="arrow-btn">
                  {isCollapsed ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </div>
              </div>
             
            </div>
          </div>
          <div className="box-list">
            {!isCollapsed &&
              files.map((file: any, index: number) => (
                <div className="bottom-section">
                  <div className="doc-icon">{renderFileIcon(file?.file)}</div>
                  <div className="file-detail">
                    <div className="file-name">
                      <div className="file-text">
                        {file?.file?.name}
                        {index}
                      </div>
                    </div>
                    <div className="file-status">
                      {file?.status !== "canceled" ? (
                        <>
                          {file.uploadProgress === 0 && (
                            <div className="avatar-container">
                              <Avatar
                                size={20}
                                className="avatar"
                                src={images.upload.empty}
                              ></Avatar>
                              <Avatar
                                size={20}
                                onClick={() => removeFile(index)}
                                src={images.upload.close}
                                className="close-icon"
                              ></Avatar>
                            </div>
                          )}
                          {file?.uploadProgress > 0 &&
                            file?.uploadProgress < 100 && (
                              <CircularProgress
                                color="success"
                                variant="determinate"
                                value={file?.uploadProgress}
                              />
                            )}
                          {file?.uploadProgress === 100 && (
                            <div className="avatar-container">
                              <Avatar
                                size={20}
                                className="avatar"
                                src={images.upload.tick}
                              ></Avatar>
                              <Avatar
                                size={20}
                                src={images.upload.folder}
                                className="close-icon"
                              ></Avatar>
                            </div>
                          )}
                        </>
                      ) : (
                        <Typography type="s4" className="canceled-text">
                          Upload Canceled
                        </Typography>
                      )}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
      </>
  );
};

export { UploadExcel };
export default UploadExcel;
